import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocationState } from "./location.state";
import { getCities, getDistricts, getNeighbourhoods } from "./location.thunk";

const initialState: LocationState = {
  cities: [],
  citiesStatus: "idle",
  citiesError: null,
  districts: {},
  districtsStatus: {},
  districtsError: null,
  neighbourhoods: {},
  neighbourhoodsStatus: {},
  neighbourhoodsError: null,
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    clearDistricts: (state, action: PayloadAction<number>) => {
      delete state.districts[action.payload];
      delete state.districtsStatus[action.payload];
    },
    clearNeighbourhoods: (state, action: PayloadAction<number>) => {
      delete state.neighbourhoods[action.payload];
      delete state.neighbourhoodsStatus[action.payload];
    },
    clearAllLocations: (state) => {
      state.cities = [];
      state.citiesStatus = "idle";
      state.citiesError = null;
      state.districts = {};
      state.districtsStatus = {};
      state.districtsError = null;
      state.neighbourhoods = {};
      state.neighbourhoodsStatus = {};
      state.neighbourhoodsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Cities
      .addCase(getCities.pending, (state) => {
        state.citiesStatus = "loading";
        state.citiesError = null;
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.citiesStatus = "success";
        state.cities = action.payload.data;
      })
      .addCase(getCities.rejected, (state, action) => {
        state.citiesStatus = "error";
        state.citiesError = action.payload ?? "Şehirler yüklenirken bir hata oluştu.";
      })

      // Get Districts
      .addCase(getDistricts.pending, (state, action) => {
        const cityId = action.meta.arg.city_id;
        state.districtsStatus[cityId] = "loading";
        state.districtsError = null;
      })
      .addCase(getDistricts.fulfilled, (state, action) => {
        const cityId = action.meta.arg.city_id;
        state.districtsStatus[cityId] = "success";
        state.districts[cityId] = action.payload.data;
      })
      .addCase(getDistricts.rejected, (state, action) => {
        const cityId = action.meta.arg.city_id;
        state.districtsStatus[cityId] = "error";
        state.districtsError = action.payload ?? "İlçeler yüklenirken bir hata oluştu.";
      })

      // Get Neighbourhoods
      .addCase(getNeighbourhoods.pending, (state, action) => {
        const districtId = action.meta.arg.district_id;
        state.neighbourhoodsStatus[districtId] = "loading";
        state.neighbourhoodsError = null;
      })
      .addCase(getNeighbourhoods.fulfilled, (state, action) => {
        const districtId = action.meta.arg.district_id;
        state.neighbourhoodsStatus[districtId] = "success";
        state.neighbourhoods[districtId] = action.payload.data;
      })
      .addCase(getNeighbourhoods.rejected, (state, action) => {
        const districtId = action.meta.arg.district_id;
        state.neighbourhoodsStatus[districtId] = "error";
        state.neighbourhoodsError = action.payload ?? "Mahalleler yüklenirken bir hata oluştu.";
      });
  },
});

export const { clearDistricts, clearNeighbourhoods, clearAllLocations } = locationSlice.actions;

export default locationSlice.reducer;
